import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=4ecff05c&scoped=true&"
import script from "./Languages.vue?vue&type=script&lang=ts&"
export * from "./Languages.vue?vue&type=script&lang=ts&"
import style0 from "./Languages.vue?vue&type=style&index=0&id=4ecff05c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecff05c",
  null
  
)

export default component.exports